export default __webpack_public_path__ + "static/10.05-1-7086182587ba3e99c00fa331e9845d90.png";